import FormularioResposta from './FormularioResposta';

export default FormularioResposta;